export default __webpack_public_path__ + "static/media/PPI-firefeature-006.cd4c8a23.jpg";